// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_f8-0";
export var headerCellHover = "_f8-1";
export var readCellContainer = "_f8-2";
export var unreadIndicator = "_f8-3";